if ( typeof SaleSizeBlock !== 'function' ) {

	class SaleSizeBlock extends HTMLElement {

		connectedCallback() {

			const sizes = ( this.dataset.sizes || '' ).split(',').map(s => s.trim()).filter(Boolean);
			if ( ! sizes.length ) return;

			const root = ( window.Shopify && Shopify.routes && Shopify.routes.root ) || '/';
			const params = new URLSearchParams();
			params.set('section_id', this.dataset.section || 'sale-size-products');
			// Same param the sandals page's own size filter uses, repeated once
			// per size (Shopify ORs repeated values of one filter), so the sale
			// collection comes back filtered to products that have one of
			// exactly these sizes available.
			sizes.forEach(size => params.append(this.dataset.param, size));

			this._abort = new AbortController();

			fetch(`${root}collections/${encodeURIComponent(this.dataset.collection)}?${params.toString()}`, { signal: this._abort.signal })
				.then(response => response.ok ? response.text() : '')
				.then(html => {
					if ( ! html ) return;
					// Parsed rather than assigned straight in, so a response with
					// no product cards (nothing on sale in that size) leaves the
					// block hidden instead of showing a heading over an empty row.
					const parsed = new DOMParser().parseFromString(html, 'text/html');
					const inner = parsed.querySelector('.sale-size-block__inner');
					if ( ! inner || ! inner.querySelector('.box__collection') ) return;
					this.replaceChildren(document.importNode(inner, true));

					// "Go to collection" opens the sale collection already filtered
					// to the same sizes (without section_id), which also skips the
					// size-picker popup that collection shows when it has no filter.
					const link = this.querySelector('[data-js-sale-size-link]');
					if ( link ) {
						const linkParams = new URLSearchParams();
						sizes.forEach(size => linkParams.append(this.dataset.param, size));
						link.href = `${root}collections/${encodeURIComponent(this.dataset.collection)}?${linkParams.toString()}`;
					}

					this.hidden = false;
				})
				.catch(() => {});

		}

		disconnectedCallback() {
			if ( this._abort ) this._abort.abort();
		}

	}

	if ( typeof customElements.get('sale-size-block') == 'undefined' ) {
		customElements.define('sale-size-block', SaleSizeBlock);
	}

}
